export default __webpack_public_path__ + "static/media/fi-br-backpack.ea2d8f81.svg";